export const tenYearsDays = 3650;
export const ltZeroDaysErrorMessage = 'Minimum value is 0 day';
export const gtTenYearsDaysErrorMessage = 'Maximum value is 3650 days';
export const eventsTablePersistanceKey = '§quality-events§events-table';
export const tasksTablePersistanceKey = '§quality-events§tasks-table';
export const eventTemplatesTablePersistanceKey = '§quality-events§event-templates-table';
export const eventsListSavedViewsTableKey = 'events-events-list';
export const stagingValpackCompanyId = 2408;
export const prodValpackCompanyId = 1505;
